import * as React from 'react';

import { cn } from '@/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                'flex field-sizing-content min-h-20 w-full rounded-md border border-neutral-200 bg-bg-surface px-3 py-2 text-sm text-text-primary transition-[border-color,box-shadow] duration-150 outline-none resize-vertical placeholder:text-neutral-400 hover:border-neutral-300 focus-visible:border-primary-300 focus-visible:shadow-[0_0_0_2px_var(--color-primary-100)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-bg-raised disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:bg-bg-surface dark:border-border-default dark:hover:border-border-strong dark:focus-visible:border-primary-600 dark:focus-visible:shadow-[0_0_0_2px_var(--color-primary-900)] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
                className,
            )}
            {...props}
        />
    );
}

export { Textarea };
